import React from 'react'
import PropTypes from 'prop-types'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBox from '../../../layout/component/ContentBox'
import { formatMoney } from '../../../../util/money'
import { Link } from 'react-router-dom'

import { PAYMENT_METHOD_TEXT, PRODUCT_TYPE } from '../../state/const'
import { renderStateName } from '../../../process/util/names'
import currentUserHasAccess from '../../../../util/widget-helper'
import { CUSTOMER_SALES_ORDER_LIST } from '../../../customer/ui-definition/customer-ui'


const SalesOrder = ({ salesOrder }) => {
    const productType = PRODUCT_TYPE[salesOrder.type]
    const viewLink = '/sales-order/edit/' + salesOrder.id
    const ratePay = salesOrder.isRatePay ? 'yes' : 'no'
    return (
        <tr>
            <td>{productType}</td>
            <td>{salesOrder.referenceNumber}</td>
            <td>{PAYMENT_METHOD_TEXT[salesOrder.paymentMethod]}</td>
            <td>{ratePay}</td>
            <td>{renderStateName(salesOrder.status)}</td>
            <td><Link to={viewLink}>view</Link></td>
            <td>{formatMoney(salesOrder.brutPrice, salesOrder.currency)}</td>

        </tr>
    )
}


const SalesOrderList = ({ salesOrderList }) => {
    if (!currentUserHasAccess(CUSTOMER_SALES_ORDER_LIST)) {
        return null
    }

    return (
        <ContentBox title="Sales Order">
            <Row>
                <Column size={12}>
                    <table className="default-table">
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>Reference Number</th>
                                <th>Payment method</th>
                                <th>Rate Pay</th>
                                <th>Status</th>
                                <th>View</th>
                                <th>Brut</th>

                            </tr>
                        </thead>
                        <tbody>
                            {salesOrderList.map(salesOrder => {
                                return <SalesOrder
                                    key={salesOrder.id}
                                    salesOrder={salesOrder}
                                />
                            })}
                        </tbody>
                    </table>
                </Column>
            </Row>
        </ContentBox>
    )
}

SalesOrderList.propTypes = {
    salesOrderList: PropTypes.array.isRequired,
}

export default SalesOrderList




// WEBPACK FOOTER //
// ./src/modules/sales-order/component/list/SalesOrderList.js